import { RequestProvider } from '@/shared/providers/request.provider';
import { ErrorProvider } from '@/shared/providers/errors.provider';
import { USER_REQUESTS_API } from '../values/user-requests.values';
import { GetUserRequestsParams, RespondUserRequestParams } from '../params/user-requests.params';

class UserRequestsClass {

  /* GET */
  async getUserRequests(data: GetUserRequestsParams){
    try {
      const url = USER_REQUESTS_API.USER_REQUESTS;
      const response: any  = await RequestProvider.get(url, data);
      return response;
    } catch(error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  async getUserRequest(requestId: number) {
    try {
      const url = USER_REQUESTS_API.GET_USER_REQUEST
      .replace('{requestId}', String(requestId));
      const response: any  = await RequestProvider.get(url);
      return response;
    } catch(error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  /* POST */
  async respondUserRequest(data: RespondUserRequestParams) {
    let body = new FormData();
    body.append('action', data.action);
    body.append('rejectionNote', data.rejectionNote);
    data.requestId.forEach(el => {
      body.append('requestId', el);
    })
    try {
      const url = USER_REQUESTS_API.USER_REQUESTS;
      const response: any  = await RequestProvider.post(url, body);
      return response;
    } catch(error) {
      throw ErrorProvider.getError(error.error);
    }
  }

}


export const UserRequestsService = new UserRequestsClass();